// ═══════════════════════════════════════════════
// ANCIENT ARCHIVES — MAIN.JS
// Scroll reveals, nav effects, page interactions
// ═══════════════════════════════════════════════

(function() {
  'use strict';

  // Scroll reveal observer
  function initReveals() {
    var elements = document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale');
    if (!elements.length) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.05, rootMargin: '0px 0px -20px 0px' });

      elements.forEach(function(el) {
        observer.observe(el);
      });

      // Fallback: after 3 seconds, force any still-hidden reveals visible
      setTimeout(function() {
        elements.forEach(function(el) {
          if (!el.classList.contains('visible')) {
            // Check if element is above the fold or already scrolled past
            var rect = el.getBoundingClientRect();
            if (rect.top < window.innerHeight + 200) {
              el.classList.add('visible');
            }
          }
        });
      }, 3000);
    } else {
      // No IntersectionObserver support — show everything
      elements.forEach(function(el) {
        el.classList.add('visible');
      });
    }

    // Also reveal on scroll as fallback
    var scrollReveal = function() {
      elements.forEach(function(el) {
        if (!el.classList.contains('visible')) {
          var rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight - 20) {
            el.classList.add('visible');
          }
        }
      });
    };
    window.addEventListener('scroll', scrollReveal, { passive: true });
    // Run once immediately
    scrollReveal();
  }

  // Stagger children animation
  function initStagger() {
    document.querySelectorAll('.stagger-children').forEach(function(parent) {
      Array.from(parent.children).forEach(function(child, i) {
        child.style.transitionDelay = (i * 80) + 'ms';
      });
    });
  }

  // Nav scroll shadow
  function initNav() {
    var nav = document.querySelector('.nav');
    if (!nav) return;
    window.addEventListener('scroll', function() {
      nav.classList.toggle('scrolled', window.scrollY > 50);
    }, { passive: true });
  }

  // Mobile nav toggle
  function initMobileNav() {
    var navToggle = document.getElementById('navToggle');
    var navLinks = document.getElementById('navLinks');
    if (navToggle && navLinks) {
      navToggle.addEventListener('click', function() {
        navLinks.classList.toggle('open');
        navLinks.classList.toggle('active');
        navToggle.classList.toggle('active');
      });
    }
  }

  // Initialize everything
  function init() {
    initReveals();
    initStagger();
    initNav();
    initMobileNav();
  }

  // Run on DOMContentLoaded or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
